import { getApiBase } from '@/lib/apiBase';
import { getSessionToken, getSessionId } from '@/lib/flowStorage';
import { getOrCreateTraceSessionId, readStoredUtm } from '@/lib/utmCapture';

const API_BASE = getApiBase();

/**
 * First-party funnel / marketing events (requires session_id — use real session or trace UUID).
 * @param {string} eventName
 * @param {{ sessionId?: string, meta?: object, source?: string }} [opts]
 */
export async function trackEvent(eventName, opts = {}) {
  try {
    const token = getSessionToken();
    const sessionId =
      String(opts.sessionId || '').trim() ||
      String(getSessionId() || '').trim() ||
      getOrCreateTraceSessionId();
    const utm = readStoredUtm();
    await fetch(`${API_BASE}/api/events`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...(token ? { 'X-Session-Token': token } : {}),
      },
      body: JSON.stringify({
        eventName,
        sessionId,
        source: opts.source || 'web',
        meta: opts.meta && typeof opts.meta === 'object' ? opts.meta : {},
        utm: {
          utm_source: utm.utm_source,
          utm_medium: utm.utm_medium,
          utm_campaign: utm.utm_campaign,
        },
      }),
    });
  } catch {
    /* non-fatal */
  }
}
